{
  "sdk-download-android": "Изтегляне за Android",
  "sdk-connect": "Свържи",
  "sdk-download-ios": "Изтегляне за iOS",
  "sdk-install": "Инсталиране",
  "sdk-modal-instruct-1": "1. Отворете приложението Binance",
  "sdk-modal-instruct-2": "2. Докоснете {{icon}} на началния екран",
  "sdk-modal-title": "Свържете се с Binance",
  "sdk-no-app": "Все още нямате приложението Binance?"
}